import { render, staticRenderFns } from "./CopyInput.vue?vue&type=template&id=ffaa047a&scoped=true&"
import script from "./CopyInput.vue?vue&type=script&lang=ts&"
export * from "./CopyInput.vue?vue&type=script&lang=ts&"
import style0 from "./CopyInput.vue?vue&type=style&index=0&id=ffaa047a&lang=sass&scoped=true&"
import style1 from "./CopyInput.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaa047a",
  null
  
)

export default component.exports